import React, {useState} from 'react';
import {StyleSheet, View} from 'react-native';
import {ThemeProvider} from '@rneui/themed';
import type {Meta, StoryObj} from '@storybook/react-native-web-vite';

import Text from '../../components/ui-controls/Text';
import rewardsTheme from '../../theme/rewardsTheme';

import FormField from './FormField';

const meta = {
  title: 'Components/Primitives/Form Field',
  component: FormField,
  decorators: [
    Story => (
      <ThemeProvider theme={rewardsTheme}>
        <View style={styles.container}>
          <Story />
        </View>
      </ThemeProvider>
    ),
  ],
} satisfies Meta<typeof FormField>;

export default meta;

type Story = StoryObj<typeof meta>;

export const FieldStates: Story = {
  render: () => {
    const [live, setLive] = useState('');

    return (
      <View style={styles.stack}>
        <Text variant="heading3">Form Field</Text>
        <FormField label="First name" required visibilityToggle placeholder="" />
        <FormField
          label="First name"
          required
          visibilityToggle
          description="As a responsible liquor retailer, RSA laws require us to verify your age before you can shop."
        />
        <Text variant="heading3">Field States</Text>
        <FormField visibilityToggle />
        <FormField state="focus" visibilityToggle defaultValue="typl" />
        <FormField state="filled" visibilityToggle defaultValue="filled" />
        <FormField state="error" visibilityToggle defaultValue="error state" />
        <FormField state="disabled" visibilityToggle defaultValue="prefilled state" />
        <Text variant="heading3">Live</Text>
        <FormField
          label="First name"
          required
          visibilityToggle
          value={live}
          onChangeText={setLive}
          description="Type, then blur, to move default → focus → filled."
        />
      </View>
    );
  },
};

export const WithErrorMessage: Story = {
  render: () => (
    <FormField
      label="First name"
      required
      error
      errorMessage="Enter your first name."
      visibilityToggle
    />
  ),
};

export const Password: Story = {
  render: () => {
    const [password, setPassword] = useState('');
    return (
      <FormField
        label="Password"
        required
        secureTextEntry
        visibilityToggle
        value={password}
        onChangeText={setPassword}
        textContentType="password"
        autoComplete="password"
      />
    );
  },
};

const styles = StyleSheet.create({
  container: {
    padding: 16,
    maxWidth: 420,
  },
  stack: {
    gap: 16,
  },
});
